import templateUrl from './form-buttons.html';

export const formButtonsComponent = {
	bindings: {
		disableButtons: '<',
		showCancelButton: '@',
		showPreviousButton: '@',
		showSubmitButton: '@',
		showNextButton: '@',
		showSavePublishButton: '@',
		showSavePublishTypeButton: '@',
		showRepublishButton: '<',
		onCancel: '&',
		onPrevious : '&',
		onNext: '&',
		onSavePublish: '&',
		onRepublish: '&'
	},
	templateUrl,
	controller: class FormButtons {
		constructor($parse) {
			'ngInject';
			this.$parse = $parse;
			this.details = {
				displayCancelButton: true,
				displayPreviousButton: false,
				displaySubmitButton: true,
				displayNextButton: false,
				displaySavePublishButton: false,
				displaySavePublishTypeButton: false
			};
		}
		
		$onInit() {
			this.details.displayCancelButton = this.$parse(this.showCancelButton || 'true')(true);
			this.details.displayPreviousButton = this.$parse(this.showPreviousButton || 'false')(false);
			this.details.displayNextButton = this.$parse(this.showNextButton || 'false')(false);
			this.details.displaySubmitButton = this.$parse(this.showSubmitButton || 'true')(true);
			this.details.displaySavePublishButton = this.$parse(this.showSavePublishButton || 'false')(false);
			this.details.displaySavePublishTypeButton = this.$parse(this.showSavePublishTypeButton || 'false')(false);

			if(this.showRepublishButton) {
				this.details.displaySubmitButton = false;
				this.details.displaySavePublishButton = false;
			}
		}
	}
};



// WEBPACK FOOTER //
// ./src/app/common/components/form-buttons/form-buttons.component.js